import { EDeliveryOption } from '@/services/types/core/delivery.types';

import { useGuidedSearchContext } from './GuidedSearchContext';

export const useGuidedSearchDeliveryInfo = () => {
  const { deliveryInfo, updateDeliveryInfo } = useGuidedSearchContext();

  const isDeliveryFullySelected = !!(
    deliveryInfo.address &&
    deliveryInfo.deliveryStationary &&
    (deliveryInfo.deliveryStationary !== EDeliveryOption.STATIONARY ||
      deliveryInfo.stationaryAcknowledged)
  );

  return { deliveryInfo, handleDeliveryChange: updateDeliveryInfo, isDeliveryFullySelected };
};
